export const downloadPDF = async (
  url,
  programmeName,
  transactionId,
  issuerOrganisation,
  isInvoice = false
) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch the file");
    }

    const disposition = response.headers.get("Content-Disposition");
    let filename = isInvoice
      ? `invoice_${transactionId}.pdf`
      : `${programmeName}_${transactionId}_${
          issuerOrganisation ? issuerOrganisation : ""
        }.pdf`;

    if (disposition && disposition.includes("attachment")) {
      const matches = /filename="([^"]*)"/.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1];
      }
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};
